<!-- Template -->

<template>
    <div v-if="visible" name="modal">
        <div
            class="modal modal-mask"
            style="display: block;"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <!-- Header -->

                    <div class="modal-header">
                        <h4 class="modal-title modal-title-with-back"><a @click.prevent="back">
                                <span class="icon-chevron-left"></span>
                            </a> <span>Open Tickets</span></h4>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <div class="modal-body with-rl-padding" >
                        <table class="table with-header tickets-open mt-0" v-show="!loading">
                            <thead v-show="openTickets.length > 0">
                                <tr>
                                    <!-- <th class="p-0">Priority</th> -->
                                    <th class="p-0">Ticket / Hospital contact</th>
                                    <th class="p-0">Status</th>
                                    <th class="p-0 r">Date opened</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="t in openTickets" :key="t.id">
                                    <!-- <td>
                                        <span
                                            class="priority small"
                                            :class="t.priorityClass"
                                        >{{t.priority}}</span>
                                    </td> -->
                                    <td>
                                        <a
                                            class="open-system"
                                            @click.prevent="openT(t)"
                                        >#{{t.id}} {{t.shortSummary}}</a>
                                        <p v-html="t.raisedBy"></p>
                                    </td>
                                    <td class="pl-0">
                                        <p>{{t.status}}</p>
                                    </td>
                                    <td class="r pr-0">
                                        <p class="text-right">{{t.date}}</p>
                                    </td>
                                </tr>
                                <tr v-show="openTickets.length <= 0">
                                    <td>
                                        <p>Tickets do not exist.</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <span v-show="loading" class="spinner-border modal-loader"></span>
                    </div>
                    
                </div>
            </div>
        </div>
        
    </div>
</template>

<!-- Script -->

<script>
    import moment from 'moment';
    import { SystemService } from "@/services/system-service";
    import { TicketService } from "@/services/ticket-service";
    
    export default {
        name: "TicketList",

        data() {
            return {
                visible: false,
                selectedSystem: null,
                openTickets: [],
                loading: true
            };
        },

        created() {
            this.systemService = new SystemService(this.$api, this.$store);
            this.ticketService = new TicketService(this.$api, this.$store);
        },

        methods: {
            async show(system) {  
                this.visible = true;
                this.selectedSystem = await this.systemService.getSystem(system.id);

                var tickets = this.selectedSystem.supportTickets;

                if (tickets.length > 0) {
                    var openedTickets = tickets.filter(function(ticket) {
                        return ticket.statusId == 1;
                    });

                    for(var i = 0; i < openedTickets.length; i++){
                        openedTickets[i].ticketDetails = await this.ticketService.getTicket(openedTickets[i].id);
                    }

                    this.openTickets = this.parseTicketArray(openedTickets);
                }

                this.loading = false;
            },

            parseTicketArray(array){
                var parsedArray = [];
                
                for(var i = 0; i < array.length; i++){
                    var t = {
                        createdByContact: array[i].createdByContact,
                        createdByContactID: array[i].createdByContactID,
                        date: array[i].statusId == 1 ? moment(array[i].dateOpened).format('DD MMM YYYY'): moment(array[i].dateClosed).format('DD MMM YYYY'),
                        description: array[i].description,
                        dhrNumber: array[i].dhrNumber,
                        id: array[i].id,
                        lastUpdated: moment(array[i].lastUpdated).format('DD MMM YYYY'),
                        ownerId: array[i].ownerId,
                        ownerName: array[i].ownerName,
                        priority: array[i].priority,
                        priorityID: array[i].priorityID,
                        productConfiguration: array[i].productConfiguration,
                        shortSummary:array[i].shortSummary,
                        status: array[i].status,
                        statusId: array[i].statusId,
                        supportTicketNature: array[i].supportTicketNature,
                        supportTicketNatureId: array[i].supportTicketNatureId,
                        systemOperable: array[i].systemOperable,
                        priorityClass:'',
                        createdInPortal: array[i].createdInPortal,
                        contactEmail: array[i].contactEmail
                    }
                    if(array[i].priorityID == 3){
                        t.priorityClass = ' low';
                    }else if(array[i].priorityID == 2){
                        t.priorityClass = ' medium';
                    }else if(array[i].priorityID == 1){
                        t.priorityClass = ' high';
                    }else{
                        t.priorityClass = ' medium';
                    }

                    parsedArray.push(t);
                }

                return parsedArray;
            },

            close() {
                this.visible = false;
                this.loading = true;
                
            },

            back(){
                this.visible = false;
                this.loading = true;
                this.$emit('close');
            },

            openT(ticket) {
                this.visible = false;
                this.$emit('showTicketDetails', {ticket: ticket, system: this.selectedSystem});
            }
        }
    };
</script>

